/**
 * Donde aterriza un anonimo en el Preview aislado.
 *
 * POR QUE EXISTE. La primera version vivia dentro de `RootLayoutApp` como un
 * `||` que decia "si no es una ruta anonima valida, o no hay destino explicito,
 * a bienvenida". La segunda mitad de ese `||` convertia el arranque en frio en
 * "redirigi TODO", y como el Preview es anonimo por definicion, la pantalla de
 * login tambien rebotaba a bienvenida: en el emulador, tocar "Iniciar Sesion"
 * volvia a la misma pantalla y la suite entera moria en `login.email-input`.
 * Un `||` que se lee como excepcion y actua como regla.
 *
 * La regla real, en una sola frase: el Preview aterriza en bienvenida como la
 * tienda, EXCEPTO cuando hay un destino explicito (un deep link que el QA uso a
 * proposito) o cuando la persona va al stack de autenticacion, que nunca se
 * interrumpe -- sin login no hay forma de entrar.
 *
 *   - rutas de autenticacion (login, registro, bienvenida, verificaciones):
 *     jamas se redirigen.
 *   - descubrimiento (explorar, tours, servicios, /preview/*) sin destino
 *     explicito: bienvenida, igual que produccion.
 *   - descubrimiento CON destino explicito (URL en web, intent en nativo):
 *     se queda; es el QA anonimo que la ruta anonima existe para permitir.
 *   - rutas protegidas: bienvenida, siempre.
 *
 * Pura y testeable a proposito: la version anterior se probaba solo por
 * consequencia en un emulador de 20 minutos.
 */
export function previewAnonymousRedirectTarget(params: {
  isPreviewBuild: boolean
  isAuthenticated: boolean
  isAuthRoute: boolean
  isAnonymousPreviewRoute: boolean
  hasExplicitBootDestination: boolean
}): '/(auth)/welcome' | null {
  if (!params.isPreviewBuild || params.isAuthenticated) return null
  if (params.isAuthRoute) return null
  if (params.isAnonymousPreviewRoute && params.hasExplicitBootDestination) return null
  return '/(auth)/welcome'
}
